import RutasComponente from '../../Configuracion/RutaComponentes'
// 1 ) Objeto que se va guardar en el contexto 
const initialState = {
    Rutas: RutasComponente.Rutas,
    RutaLogin: RutasComponente.RutaLogin,
    RutaHome: RutasComponente.RutaHome,
    RutaNotFound: RutasComponente.RutaNotFound,
    RutaRecorevyPassword: RutasComponente.RutaRecorevyPassword,
    RutaRecorevyPasswordSussed: RutasComponente.RutaRecorevyPasswordSussed,
    RutaChangePassword: RutasComponente.RutaChangePassword,
    Modulo: RutasComponente.Modulo
};

// 2 ) Logica de manejo de la variable 
const autorizacionReducer = (state = initialState, action) => {
    switch (action.type) {
        case "AUTORIZACION":
            return {
                ...state,
                Rutas: action.autorizacion.Rutas,
                RutaLogin: action.autorizacion.RutaLogin,
                RutaHome: action.autorizacion.RutaHome,
                RutaNotFound: action.autorizacion.RutaNotFound,
                RutaRecorevyPassword: action.autorizacion.RutaRecorevyPassword,
                RutaRecorevyPasswordSussed: action.autorizacion.RutaRecorevyPasswordSussed,
                RutaChangePassword: action.autorizacion.RutaChangePassword,
                Modulo: action.autorizacion.Modulo
            }
        default: return state;
    }
};

//3 se exporta el comporamiento que administra la variable pra poder usarse 
export default autorizacionReducer;